export default __webpack_public_path__ + "static/media/powerreader_locked.72a9ba24.svg";